mutation updateCompanyAmbassador($input: UpdateAmbassadorInput!) {
  ambassador: updateCompanyAmbassador(input: $input) {
    id
    salutation
    firstname
    lastname
    name
    role
    email
    image {
      url
      id
    }
    phone
    mobile
    linkedin
    instagram
    facebook
    twitter
    signature {
      html
      text
      customTemplateSignature
    }
  }
}
